export default function getPlaceholders (message: string) {
  const array = [...message.matchAll(/{[\w\s]+}/g)].flat().map(item => item.toLowerCase())
  return array.filter((item, index) => {
    return array.indexOf(item) === index
  })
}
